import moment from 'moment'
const hys = {
    loadName: '',
    isLoading: false,
    /**
     * 判断手机号码
     * @param {*} val 需要判断的号码
     * @param {*} type 判断类型(0:任意类型,1：手机号码,2：座机号码)
     */
    ValidatePhone: (val, type) => {
        var isMob = /^([0-9]{3,4}-)?[0-9]{7,8}$/ // 座机格式
        var isPhone = /^0?1[0-9]\d{9}$/ //手机号码
        switch (type) {
            case 0:
                return isMob.test(val) || isPhone.test(val)
            case 1:
                return isPhone.test(val)
            case 2:
                return isMob.test(val)
            default:
                return false
        }
    },
    // 替换输入框中空格
    replaceBlank: (value) => {
      return value
        .replace(/\s+/g, "")
        .replace(/[A-Za-z]+/g, "")

    },
    // 替换输入框中空格和特殊字符
    replaceBlankAndSpecial: (value) => {
      return value
        .replace(/\s+/g, "")
        .replace(/[/\\|^|?|%|&|:|*|<|>|。|“|"|？|$|：|”]/g, "");
    },
    // 替换输入空格和特殊字符，并将O转换为0
    replaceBlankSpecialAndO: (v) => {
      return v
        .replace(/\s+/g, "")
        .replace(/[/\\|^|?|%|&|:|*|<|>|。|“|"|？|$|：|”]/g, "")
        .replace(/O/g, "0");
    },
    formateDatetime(time, formatStr) {
        return moment(time).format(formatStr)
    },
    openLoading() {
        var maxzindex = [...document.all].reduce(
            (r, e) => Math.max(r, +window.getComputedStyle(e).zIndex || 0),
            0
        )
        hys.isLoading = true
        hys.loadName = 'hysloading'
        let el = document.getElementById(hys.loadName + 'div')
        if (el) {
            return
        }
        let load = document.createElement('div')
        load.id = hys.loadName
        const loadDiv = document.createElement('div')
        loadDiv.id = hys.loadName + 'div'
        loadDiv.className = 'loadingBigWrap'
        loadDiv.style.zIndex = maxzindex + 2
        loadDiv.innerHTML =
            '<div class="loadingWrap"><div class="loading"><div class="bounce1"></div>	<div class="bounce2"></div>	<div class="bounce3"></div><span></span><span></span></div></div>'
        document.body.append(loadDiv)
        //document.body.style.overflow = "hidden";
    },
    clearLoading() {
        hys.isLoading = false
        let el = document.getElementById(hys.loadName + 'div')
        if (!el) {
            return
        }

        document.body.style.overflow = 'auto'
        if (!hys.loadName) {
            return null
        }
        var load = document.getElementById(hys.loadName)
        if (load) {
            document.body.removeChild(load)
        }
        load = document.getElementById(hys.loadName + 'div')
        if (load) {
            document.body.removeChild(load)
        }
    },

    //-------------------------------------业务数据工具函数------------------------------
    /**
     * 获取购物车数量，会自动发送通知
     * @param {Boolean} isCard 是否需要刷新购物车商品数据
     */
    async getCartCount(_this, isCard) {
        if (!_this) {
            return
        }
        const res = await _this.getAction('/api_order/ShoppingCarts/Count')
        if (res.IsSuccess) {
            _this.$bus.$emit(
                'buycarChanged',
                res.Data.ProductCount,
                isCard || true
            )
            _this.$bus.$emit(
                'rightBuycarChanged',
                res.Data.ProductCount,
                isCard || true
            )
        }
    },

    // 判断单笔限购数量
    // step步长  LimitPerOrder单次限购数量 PurchaseNumber 起购数
    checkLimitPerOrder(PurchaseNumber, step, LimitPerOrder) {
        if (step == 0) {
          return LimitPerOrder;
        }
        let no = Math.floor(
            (LimitPerOrder * 1 - PurchaseNumber * 1) / (step * 1)
        )
        let mun = PurchaseNumber + step * no        
        return mun
    },

    //----------------------------------------------------------------------------------
}

const install = (Vue) => {
    Vue.prototype.$hys = Vue.prototype.hys = hys
    Vue.$hys = Vue.hys = hys
}
export default {
    install,
}
